module.exports = __webpack_public_path__ + "static/media/tw.7794932d.svg";